// 🔧 homepage_step.js
// ✅ Purpose: Homepage Builder pipeline step
// ✅ Features:
// - Executes Homepage Builder
// - Updates DemoContext
// - Keeps homepage generation modular
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";

import {
  buildHomepageShell,
} from "../../builders/homepage_builder";

export const createHomepageStep =
() => ({

  name: "homepage_builder",

  label: "Homepage Builder",

  run: async (context) => {

    const result =
      await buildHomepageShell(
        context
      );

    return createPipelineStepSuccess({

      step:
        "homepage_builder",

      label:
        "Homepage Builder",

      created:
        result?.createdCount || 0,

      message:
        result?.message,

      metadata:
        result,

      startedAt:
        context.startedAt,

    });

  },

  afterSuccess:
    ({
      result,
      sharedContext,
    }) => {

      sharedContext.homepageResult =
        result?.metadata || null;

    },

});